import '../../register-web-components';
import { ReactElement, useEffect, useState } from 'react';
import Footer from '../footer';
import Head from 'next/head';
import styles from './appLayout.module.scss';
import { loadScript } from '../../lib/utils/utils';
import Script from 'next/script';
import { Tile } from '@digital-pulse/react';
import Header from '../header';
type Props = {
  pageTitle: string;
  children: ReactElement;
  pageName?: string;
};

const isGitPreview = process?.env?.NEXT_PUBLIC_APP_ENV === 'preview';

const AppLayout = ({ pageTitle, children, pageName }: Props) => {
  const title = pageTitle;

  return (
    <>
      <Script
        id={'appdScript'}
        type={'text/javascript'}
        src={'https://www.cvs.com/static/scripts/appd.js'}
        data-appname={'/app-store-review'}
        data-pagename={pageName || 'App Store Review'}
        data-title={'App-store-review'}
        onLoad={() => {
          loadScript('https://cdn.appdynamics.com/adrum/adrum-latest.js', 'adrumLatest');
        }}
      />
      <Head>
        <title>{title}</title>
        <meta name="description" content={'Provide feedback on mobile app experience'} />
      </Head>
      <div className={styles.guest__container}>
        <Header />
        <main className={styles.guest__main}>
          <Tile className={styles.card}>{children}</Tile>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AppLayout;
